import Vue from 'vue';
import VueGtag from 'vue-gtag';
import { gtagAccounts } from '~/constants/gtagAccounts';

Vue.use(VueGtag, {
  config: { id: gtagAccounts.bonkers_search_nb_insurance.id },
  includes: [
    { id: gtagAccounts.google_new_account.id },
    { id: gtagAccounts.bonkers_search_nb.id },
    { id: gtagAccounts.bonkers_display_nb.id },
    { id: gtagAccounts.bonkers_search_brand.id }
  ]
});
